// Shared EMR registry — used by LogosStrip, Integration pages, and notify modal.
// Marking integrations as `live` or `soon` controls UX (deep-dive page vs notify modal).
export const EMRS = [
  {
    slug: "juvonno",
    name: "Juvonno",
    domain: "juvonno.com",
    url: "https://juvonno.com",
    logo: "https://www.google.com/s2/favicons?domain=juvonno.com&sz=256",
    status: "live",
    tagline: "The full-stack EMR for multi-disciplinary clinics in Canada.",
    accent: "from-cyan-500 to-teal-500",
    brandHex: "#0ea5e9",
    short:
      "Real-time, two-way sync between Clinic OS and Juvonno. Bookings made by AI Receptionist write directly into Juvonno's schedule — and Juvonno's availability is read back so no double-booking ever happens.",
    suited: ["Physiotherapy", "Chiropractic", "Massage", "Multi-discipline clinics"],
  },
  {
    slug: "jane-app",
    name: "Jane App",
    domain: "jane.app",
    url: "https://jane.app",
    logo: "https://www.google.com/s2/favicons?domain=jane.app&sz=256",
    status: "live",
    tagline: "The clinic platform loved by health & wellness practitioners.",
    accent: "from-emerald-500 to-teal-500",
    brandHex: "#16a34a",
    short:
      "Native two-way Jane App integration. Schedules, charts, billing and recall flow stay in sync — AI Receptionist books straight into Jane in real time.",
    suited: ["Physiotherapy", "Massage", "Naturopathy", "Mental health", "Chiropractic"],
  },
  {
    slug: "cliniko",
    name: "Cliniko",
    domain: "cliniko.com",
    url: "https://cliniko.com",
    logo: "https://www.google.com/s2/favicons?domain=cliniko.com&sz=256",
    status: "soon",
  },
  {
    slug: "pt-everywhere",
    name: "PT Everywhere",
    domain: "pteverywhere.com",
    url: "https://pteverywhere.com",
    logo: "https://www.google.com/s2/favicons?domain=pteverywhere.com&sz=256",
    status: "soon",
  },
  {
    slug: "opendental",
    name: "OpenDental",
    domain: "opendental.com",
    url: "https://opendental.com",
    logo: "https://icon.horse/icon/opendental.com",
    status: "soon",
  },
  {
    slug: "abeldent",
    name: "AbelDent",
    domain: "abeldent.com",
    url: "https://abeldent.com",
    logo: "https://www.google.com/s2/favicons?domain=abeldent.com&sz=256",
    status: "soon",
  },
];

export const findEmrBySlug = (slug) => EMRS.find((e) => e.slug === slug);
